<template>
  <v-row class="home">
    <!-- alert -->
    <v-col cols="12" class="pa-0" v-if="Object.keys(alertCertificate).length && alertCertificate.show_notification">
      <v-alert class="mb-3 inf-alert-error" text outlined color="red-500" rounded dense>
        <div class="d-flex pa-0 align-center">
          <v-icon color="red-500">mdi-alert</v-icon>
          <div class="ml-5 alert-description-dash">
            <span class="body-1 font-weight-bold red--500">Certificado digital</span>
            <span class="d-block body-2 red-500--text pb-1">
              <template v-if="alertCertificate.status === 'active'">
                Te queda{{alertCertificate.days_left > 1 ? 'n' : ''}} <span class="font-weight-bold">{{alertCertificate.days_left }} {{ alertCertificate.days_left > 1 ? 'días' : 'día'}}</span> restantes, con fecha de vencimiento:
              </template>
              <template v-else>Tu certificado digital venció el</template>
              <span class="font-weight-bold"> {{ alertCertificate.date_end | dateBar }}</span>
            </span>
          </div>
          <v-spacer />
          <v-btn v-if="$helpers.hasPermission(['add_genericcertificate'])" :to="{ name: 'IrsBuiltInSettings' }" color="red-500">Gestionar certificado</v-btn>
        </div>
      </v-alert>
    </v-col>
    <!-- end alert -->
    <v-col cols="12" class="pa-0 mt-3">
      <v-card class="panel-home" width="100%" height="180" :style="`margin-bottom:${setMarginBottom}`">
        <v-img min-width="100%" :min-height="200" :src="require(`@/assets/backgrounds/background-panel-hello${$vuetify.theme.dark ? '--dark' : ''}.svg`)">
          <v-row class="fill-height ma-0" align="center">
            <span class="d-block pl-12 title-panel blue-500--text">¡Hola{{ $store.state.auth.userAccount.first_name ? ` ${$store.state.auth.userAccount.first_name}`: ''}}!
              <span class="d-inline-block text-h1 ml-3" style="margin-top: -20px; position: absolute">👋🏼</span>
            </span>
          </v-row>
        </v-img>
      </v-card>
      <v-col class="px-0 text-end">
        <v-btn :class="$vuetify.breakpoint.width >= 2000 ? 'mt-n3 mb-2' : 'mt-n8'" @click="dialog=true" text color="blue-500" :ripple="false">
          <span class="font-weight-medium body-1">Editar accesos directos</span>
          <v-icon small>mdi-arrow-top-right-thick</v-icon>
        </v-btn>
        <v-row v-for="(shortcut, i) in currentShortcutsList" :key="i">
          <v-col cols="3" class="" v-for="children in shortcut.children" :key="children.title">
            <!-- <v-hover v-slot="{ hover }"> -->
              <v-card class="px-5 py-7" :to="{ name: children.route }" height="80" min-width="190"> <!--:elevation="hover ? 6 : 0"-->
                <v-row class="fill-height ma-0 text-left" align="center">
                  <v-img contain :height="44" style="position: absolute" :src="require(`@/assets/shortcuts-icons/avatars/${children.icon}--avatar.svg`)" />
                  <span class="d-inline-block defaultGrey--text font-weight-bold ml-14 pl-2" :class="$vuetify.breakpoint.width <= 1200 ? 'body-1' : 'subtitle-1'" style="line-height: normal" >{{ children.title === 'SII' ? $t('generals.SII') : children.title}}</span>
                </v-row>
              </v-card>
            <!-- </v-hover> -->
          </v-col>
        </v-row>
      </v-col>
    </v-col>
    <!-- dialog export -->
    <v-dialog v-model="dialog" width="1020" persistent scrollable no-click-animation overlay-color="grey-500">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="46" class="transparent">
            <v-toolbar-title class="px-5 subtitle-2 grey-700--text font-weight-semibold">Accesos directos</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-3">
                <v-btn @click="dialog=false" icon small retain-focus-on-click><v-icon color="grey-300--text" size="20">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0">
          <!-- alert -->
          <v-alert class="inf-alert blue-500--text" :height="50" dense text outlined tile>
            <div class="d-flex pa-0">
              <v-icon color="blue-500" size="22">mdi-information</v-icon>
              <div class="ml-4 py-1">
                <span class="body-1">Selecciona hasta
                  <span class="font-weight-bold">8 accesos directos</span>
                </span>
              </div>
            </div>
          </v-alert>
          <!-- end alert -->
          <v-col class="px-5 pb-6" v-for="section in shortcutsByCountry" :key="section.title">
            <span class="font-weight-bold subtitle-2 defaultGrey--text">{{ section.title }}</span>
            <v-row class="mt-5" no-gutters>
              <v-col cols="2" class="pr-2" v-for="children in section.children" :key="children.title" style="min-width: 16.6% !important;">
                <v-card class="pa-3" outlined awidth="235" style="border-radius: 5px">
                  <v-row class="ma-0" align="center">
                    <v-sheet height="40">
                      <v-row class="ma-0" align="center">
                        <v-img contain :height="44" style="position: absolute" :src="require(`@/assets/shortcuts-icons/${ section.title === 'Configuración' ? children.icon : section.icon}--icon.svg`)" />
                        <v-sheet class="ml-6 body-2 align-center d-flex defaultGrey--text" width="90" height="40" style="line-height: normal">{{ children.title === 'SII' ? $t('generals.SII') : children.title }}</v-sheet>
                        <v-checkbox class="mt-n1" :input-value="list.includes(children.title) || false"  @click="getShortcuts(children.title)" :ripple="false" dense hide-details style="position: absolute; right: 0"/>
                      </v-row>
                    </v-sheet>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-2 px-5">
          <v-spacer/>
          <v-btn outlined @click="dialog=false" :ripple="false">Cancelar</v-btn>
          <v-btn color="blue-500" @click="saveShortCuts" :ripple="false" :disabled="list.length <= 3 || list.length > 8">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog export -->
  </v-row>
</template>
<script>
import GenericViewMixin from '@/mixins/GenericViewMixin'
export default {
  mixins: [
  GenericViewMixin
  ],
  data: () => ({
    loadingAlertCertificate: false,
    alertCertificate: {},
    dialog: false,
    list: [],
    listCL: ['Documentos emitidos', 'Crear documentos', 'Emisión por lotes', 'Disponibilidad', 'Directorio usuarios', 'Directorio roles', 'Notificaciones', 'Clientes'],
    listPE: ['Documentos emitidos', 'Tienda', 'POS', 'Directorio usuarios', 'Directorio roles', 'Notificaciones', 'Clientes'],
    currentShortcutsList: [],
    shortcuts: [
      {
        icon: 'documents',
        title: 'Emisión',
        description: '',
        countries: ['CL', 'PE'],
        children: [
          {
            icon: 'documents',
            title: 'Documentos emitidos',
            route: 'DocumentsList',
            countries: ['CL', 'PE']
          },
          {
            icon: 'documents',
            title: 'Crear documentos',
            route: 'DocumentsCreate',
            countries: ['CL', 'PE']
          },
          {
            icon: 'documents',
            title: 'Emisión por lotes',
            route: 'DocumentsBatchListCreate',
            countries: ['CL', 'PE']
          },
          {
            icon: 'documents',
            title: 'Clientes',
            route: 'CustomerListCreate',
            countries: ['CL', 'PE']
          }
          // {
          //   icon: 'documents',
          //   title: 'Productos',
          //   route: ''
          // }
        ]
      },
      {
        icon: 'purchases',
        title: 'Recepción',
        description: '',
        countries: ['CL'],
        children: [
          {
            icon: 'purchases',
            title: 'Documentos recibidos',
            route: 'PurchaseList',
            countries: ['CL']
          },
          // {
          //   icon: 'purchases',
          //   title: 'Cesión',
          //   route: ''
          // },
          // {
          //   icon: 'purchases',
          //   title: 'Automati-zación',
          //   route: ''
          // },
          {
            icon: 'purchases',
            title: 'Proveedores',
            route: 'SupplierListCreate',
            countries: ['CL']
          }
          // {
          //   icon: 'purchases',
          //   title: 'Grupos',
          //   route: ''
          // }
        ]
      },
      {
        icon: 'folios',
        title: 'Folios',
        description: '',
        countries: ['CL', 'PE'],
        children: [
          {
            icon: 'folios',
            title: 'Disponibilidad',
            route: 'FoliosListCreate',
            countries: ['CL']
          }
        ]
      },
      {
        icon: 'pos',
        title: 'POS',
        description: '',
        countries: ['CL', 'PE'],
        children: [
          {
            icon: 'pos',
            title: 'Tiendas',
            route: 'BranchListCreate',
            countries: ['CL', 'PE']
          },
          {
            icon: 'pos',
            title: 'POS',
            route: 'PosListCreate',
            countries: ['CL', 'PE']
          }
        ]
      },
      {
        icon: 'reports',
        title: 'Reportes',
        description: '',
        countries: ['CL', 'PE'],
        children: [
          {
            icon: 'reports',
            title: 'Envío de documentos',
            route: 'SentDocumentList',
            countries: ['CL', 'PE']
          },
          {
            icon: 'reports',
            title: 'Registro de ventas',
            route: 'DocumentSummary',
            countries: ['CL']
          }
        ]
      },
      {
        icon: 'account',
        title: 'Configuración',
        description: '',
        countries: ['CL', 'PE'],
        children: [
          {
            icon: 'account',
            title: 'Organización',
            route: 'AccountBasic',
            countries: ['CL', 'PE']
          },
          {
            icon: 'sii',
            title: 'SII',
            route: 'IrsBuiltInSettings',
            countries: ['CL', 'PE']
          },
          {
            icon: 'directory',
            title: 'Directorio usuarios',
            route: 'AccountMembers',
            countries: ['CL', 'PE']
          },
          {
            icon: 'directory',
            title: 'Directorio roles',
            route: 'AccountGroups',
            countries: ['CL', 'PE']
          },
          {
            icon: 'developers',
            title: 'Developers',
            route: 'AccountSettingsWebhooksListCreate',
            countries: ['CL', 'PE']
          },
          {
            icon: 'notifications',
            title: 'Notificaciones',
            route: 'AccountNotifications',
            countries: ['CL', 'PE']
          }
        ]
      }
    ]
  }),
  computed: {
    setMarginBottom () {
      if (this.$vuetify.breakpoint.width < 1400) return '4%'
      else if (this.$vuetify.breakpoint.width < 1500) return '5%'
      else if (this.$vuetify.breakpoint.width < 1700) return '6.5%'
      else if (this.$vuetify.breakpoint.width < 1900) return '7%'
      return '9.5%'
    },
    shortcutsByCountry () {
      return this.shortcuts.filter((item) => item.children.some((children) => this.list.includes(children.title) || children.countries.includes(this.$store.state.auth.account.country)))
    }
  },
  created () {
    this.list = this.$store.state.auth.account.country === 'CL' ? [...this.listCL] : [...this.listPE]
  },
  mounted () {
    this.setShortCuts()
    this.loadingAlertCertificate = true
    this.$store.dispatch('accounts/LIST', {
      resource: 'irs/certificates/expiration_alert'
    })
    .then((response) => {
      this.alertCertificate = response.data
    })
    .catch(() => {
      this.alertCertificate = {}
    })
    .finally(() => {
      this.loadingAlertCertificate = false
    })
  },
  watch: {
    '$store.state.auth.account.id' (val) {
      this.list = val === 'CL' ? this.listCL : this.listPE
    }
  },
  methods: {
    /* eslint-disable */
    getShortcuts (val = null) {
      if (!this.list?.find((s) => s === val)) this.list.push(val)
      else {
        this.list.splice(this.list?.indexOf(val), 1)
        this.list = [...this.list]
      }
    },
    saveShortCuts () {
      let recovery = JSON.parse(localStorage.getItem('shortcuts-axt')) ?? []
      const index = recovery?.findIndex(({account_id}) => account_id === this.$store.state.auth.account.id)
      if (index !== -1) {
        recovery[index].shortcuts = this.list
      } else {
        recovery.push({ account_id: this.$store.state.auth.account.id, shortcuts: this.list })
      }

      localStorage.setItem('shortcuts-axt', JSON.stringify(recovery))
      this.setShortCuts()
      this.dialog = false
    },
    setShortCuts () {
      const recovery = JSON.parse(localStorage.getItem('shortcuts-axt'))
      const found = recovery?.find(({account_id}) => account_id === this.$store.state.auth.account.id)
      if (found || this.list.length) {
        this.list = found?.shortcuts ?? this.list
        let array = []
        this.shortcuts?.forEach((item) => {
          item.children.forEach((children) => {
            const receive = item.children.findIndex(({ title }) => title === 'Documentos recibidos')
            if (receive === 0 && !item.children.find(({ title }) => title === 'Pendiente por recibir') && this.$store?.state?.auth?.account?.auto_purchase_sii) {
              item.children[receive].title = 'Recibidos'
              item.children.splice(1, 0, {
                icon: 'purchases',
                title: 'Pendiente por recibir',
                route: 'PendingReceiveList',
                countries: ['CL']
              })
            }

            if (this.list.includes(children.title) && children.countries.includes(this.$store.state.auth.account.country)) {
              array.push(children)
              this.currentShortcutsList = [{ ...item, children: array}]
            }
          })
        })
      }
    }
  }
}
</script>